@if (notifications$ | async; as notifications) {
  @for (position of positions; track position) {
    @if (toastsForPosition(notifications, position).length) {
      <div class="toast-host toast-host--{{ position }}">
        @for (toast of toastsForPosition(notifications, position); track toast.id) {
          <div
            class="toast toast--{{ toast.tone }}"
            [class.toast--closing]="toast.closing"
            role="alert"
            aria-live="assertive"
          >
            <span class="toast__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                  d="M12 2a10 10 0 1 0 10 10A10.012 10.012 0 0 0 12 2Zm0 4.5a1 1 0 0 1 1 1v5.5a1 1 0 1 1-2 0V7.5a1 1 0 0 1 1-1Zm0 11a1.25 1.25 0 1 1 1.25-1.25A1.252 1.252 0 0 1 12 17.5Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span class="toast__message">{{ toast.message }}</span>
            <button
              class="toast__close"
              type="button"
              aria-label="Cerrar notificacion"
              (click)="dismiss(toast.id)"
            >
              ×
            </button>
          </div>
        }
      </div>
    }
  }
}
